import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { Entity } from '@data/models/entity.model';

@Component({
    selector: 'syn-bot-acls-details-dialog',
    templateUrl: 'bot-acls-details-dialog.component.html'
})
export class BotAclsDetailsDialogComponent {

    public displayedColumns = ['id', 'READ', 'EDIT', 'ADMIN'];
    public dataSource: MatTableDataSource<{ id: string; read: boolean; edit: boolean; admin: boolean }>;
    public dataCount = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            entities: Entity[];
            scopes: string[];
        }
    ) {
        const dataSource = data.entities.sort((o1, o2) => o1.id > o2.id ? 1 : -1).map((entity) => {
            return {
                id: entity.id,
                read: data.scopes.includes(`${entity.id}:read`),
                edit: data.scopes.includes(`${entity.id}:edit`),
                admin: data.scopes.includes(`${entity.id}:admin`),
            };
        });
        this.dataSource = new MatTableDataSource(dataSource);
        this.dataCount = dataSource.length;
    }

}
